export const PoweredBy = () => {
	return (
		<div className="text-sm text-muted-foreground">
			Powered by{" "}
			<a
				href="https://statoos.dev"
				target="_blank"
				rel="noopener noreferrer"
				className="font-bold font-mono text-foreground"
			>
				statoos
			</a>
		</div>
	);
};
